// extracted by mini-css-extract-plugin
export var filterIncDec = "_db-0";
export var leftBorder = "_db-1";
export var rightBorder = "_db-2";
export var stringInput = "_db-3";